import React from 'react';
import { Box, Checkbox, Typography, Tooltip, IconButton, CircularProgress, } from '@mui/material';
const theme = createTheme();
import { createTheme } from '@mui/material/styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AttachmentOutlinedIcon from '@mui/icons-material/AttachmentOutlined';
import EmailIcon from '@mui/icons-material/EmailOutlined';

const InvitationRow = (props) => {
    const {item, index, classes} = props;
    let actData = item.actualData;

    return (
        <Box className={classes.cardRowContent}>
            {/* {data[index].actualData.name} */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.1', justifyContent: 'center' }}>
                <Checkbox
                    inputProps={{
                        'aria-label': 'Invitation',
                    }}
                    checked={item.selected ? item.selected : false}
                    onChange={(event) => props.onCheckSelect(event, index)}
                    // color="secondary"
                    value={actData.invitationID}
                    sx={{ marginLeft: theme.spacing(-1) }}
                // disabled={
                //     item.disableRow != undefined ? item.disableRow : false
                // }
                />
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.15', justifyContent: 'left' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={400}>
                        <span>{actData.participant}</span>
                        <Typography
                            fontSize={11}
                            sx={{
                                wordBreak: 'break-word',
                            }}>
                            <a
                                href={`mailto:${actData.emailID}`}>
                                {' '}
                                {actData.emailID}{' '}
                            </a>
                        </Typography>                        
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.15', justifyContent: 'left' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start', justifyContent: 'left' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={500}
                        color="primary">
                        Template
                    </Typography>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={400}>
                            <Tooltip title={actData.templateName}>
                                <span className={classes.wrapAll}>{actData.templateName}</span>
                            </Tooltip>
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.18', justifyContent: 'left' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start', justifyContent: 'left' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={500}
                        color="primary">
                        cc
                    </Typography>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={400}>
                            <Tooltip title={actData.ccEmailID}>
                                <span className={classes.wrapAll}>{actData.ccEmailID}</span>
                            </Tooltip>
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.17', justifyContent: 'left' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start', justifyContent: 'left' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={500}
                        color="primary">
                        bcc
                    </Typography>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={400}>
                            <Tooltip title={actData.bccEmailID}>
                                <span className={classes.wrapAll}>{actData.bccEmailID}</span>
                            </Tooltip>
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.1', justifyContent: 'left' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'start', justifyContent: 'left' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={500}
                        color="primary">
                        Status
                    </Typography>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={400}>
                        <span>Pending</span>
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.15', justifyContent: 'flex-end', }}>
                <Tooltip title="Attachment" aria-label="attachments">
                    <IconButton color="primary">
                        <AttachmentOutlinedIcon
                            fontSize="small"
                            color={
                                item.disableRow != undefined
                                    ? 'default'
                                    : 'primary'
                            }
                        />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Edit" aria-label="edit">
                {(props.editLoading.loading && props.editLoading.index === index)? 
                   <IconButton>
                        <CircularProgress
                            sx={{ color: 'black' }}
                            size={20}
                        />
                    </IconButton>
                    :
                    <IconButton
                        color="primary"
                        onClick={() => props.editRow(item, index)}>
                        <EditOutlinedIcon
                            fontSize="small"
                            color={'primary'}
                        />
                    </IconButton>}
                </Tooltip>
                <Tooltip title="Send" aria-label="send">
                { (props.emailLoading.loading && props.emailLoading.index === index)? 
                   <IconButton title="Send">
                        <CircularProgress
                            sx={{ color: 'black' }}
                            size={20}
                        />
                    </IconButton>
                    :
                    <IconButton
                        color="primary"
                        onClick={() => props.editSendEmail(item, index)}
                        disabled={
                            item.disableRow != undefined
                                ? item.disableRow
                                : false
                        }>
                        <EmailIcon
                            fontSize="small"
                            color={
                                item.disableRow != undefined
                                    ? 'default'
                                    : 'primary'
                            }
                        />
                    </IconButton>}
                </Tooltip>
            </Box>
        </Box>
    )
}

export default InvitationRow;